import { xyCumulativeDistributionStatistics } from 'ml-spectra-processing';

export function getStats(spectrum) {
  let stats = {};
  if (spectrum.variables.x && spectrum.variables.y) {
    let data = {
      x: spectrum.variables.x.data,
      y: spectrum.variables.y.data,
    };

    const weightStats = xyCumulativeDistributionStatistics(data);
    stats.weight = {
      diameter25: { value: weightStats.x25, units: spectrum.variables.x.units },
      diameter50: { value: weightStats.x50, units: spectrum.variables.x.units },
      diameter75: { value: weightStats.x75, units: spectrum.variables.x.units },
      diameterMode: {
        value: weightStats.xMode,
        units: spectrum.variables.x.units,
      },
      diameterMean: {
        value: weightStats.xMean,
        units: spectrum.variables.x.units,
      },
      diameterWidth50: {
        value: weightStats.x75 - weightStats.x25,
        units: spectrum.variables.x.units,
      },
    };
  }

  if (spectrum.variables.x && spectrum.variables.n) {
    let data = {
      x: spectrum.variables.x.data,
      y: spectrum.variables.n.data,
    };
    const numberStats = xyCumulativeDistributionStatistics(data);
    stats.number = {
      diameter25: { value: numberStats.x25, units: spectrum.variables.x.units },
      diameter50: { value: numberStats.x50, units: spectrum.variables.x.units },
      diameter75: { value: numberStats.x75, units: spectrum.variables.x.units },
      diameterMode: {
        value: numberStats.xMode,
        units: spectrum.variables.x.units,
      },
      diameterMean: {
        value: numberStats.xMean,
        units: spectrum.variables.x.units,
      },
      diameterWidth50: {
        value: numberStats.x75 - numberStats.x25,
        units: spectrum.variables.x.units,
      },
    };
  }
  return stats;
}
